<template>
    <div id="term_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="termHeader" v-if="$route.params.id > 0">Update Representative</span>
                    <span class="page-title" id="termHeader" v-else>Add Representative</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackTermList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content term-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="RepForm">
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="module">Module:</label>
                                        <v-select type="text" class="custom-ci-auto-search close-remove" v-model="repModule" label="text" :options="repModuleArr" id="module" placeholder="Select Module" name="module"></v-select>
                                        <div class="field-error">{{module_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_id">Location:</label>
                                        <v-select type="text" class="custom-ci-auto-search close-remove" v-model="locationId" label="text" :options="locationArr" id="location_id" placeholder="Select Location" name="location_id"></v-select>

                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label " for="telephone">Phone Number:</label>
                                        <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="telephone" :id="'telephone' + index" placeholder="999-999-9999" name="telephone">
                                        <!-- <input-mask id="telephone" :alwaysShowMask="true" name="telephone" v-model="telephone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                        <div class="field-error">{{telephone_error_msg}}</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-col-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateTermBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateRepresentative" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateTermBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateRepresentative" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueRepBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateRepresentative(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelRepBtn" class="btn btn-tertiary" v-on:click.prevent="BackTermList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
    name: "TermCreate",
    metaInfo() {
        return {title: (this.$route.params.id > 0)? "Update Representative | " +process.env.COPYRIGHT_NAME : "Create Representative | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,contractMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        locationArr:[],
        name: "",
        locationId: "",
        loading:false,
        name_error_msg: "",
        module_error_msg: "",
        repModule: null,
        telephone: "",
        telephone_error_msg: "",
        code:'',
        code_error_msg:'',

    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_representative') {
                        self.cantAccessPage = true;
                    }
                }
            }
        }
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();

        this.loadFieldData(['location']);

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadRepresentative();
            }
        }, 100);
    },
    methods: {

        BackTermList() {
            var self = this;
            self.$router.push("/representative/list");
        },

        CreateRepresentative(flag) {
            var self = this;

            self.name = self.name.trim();

            self.name_error_msg = "";
            self.module_error_msg = "";
            self.telephone_error_msg = "";
            self.code_error_msg = '';
            var error = false;

            if (!self.name || self.name == null || self.name == "") {
                self.name_error_msg = "Name Required.";
                error = true;
            }

            if (!self.code || self.code == null || self.code == "") {
                self.code_error_msg = "Code Required.";
                error = true;
            }

            if ( self.repModule == null || self.repModule == '' || !self.repModule.value ) {
                self.module_error_msg = "Please select Module.";
                error = true;
            }
            var workPhoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            if(self.telephone && !self.telephone.match(workPhoneRE)  && self.telephone!='___-___-____'){
                self.telephone_error_msg = "Phone number must be in proper format.";
                error = true;
            }

            if ( error == false ) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    if (segments[3])
                    {
                        $("#CreateRepBtn").val("Updating ...");
                        $("#CreateRepBtn").prop("disabled", true);
                        $("#cancelRepBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueRepBtn").val("Saving ...");
                            $("#CreateRepBtn").prop("disabled", true);
                            $("#createAndContinueRepBtn").prop("disabled", true);
                            $("#cancelRepBtn").prop("disabled",true);

                        }else{

                            $("#CreateRepBtn").val("Saving ...");
                            $("#CreateRepBtn").prop("disabled", true);
                            $("#createAndContinueRepBtn").prop("disabled", true);
                            $("#cancelRepBtn").prop("disabled",true);
                        }

                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/representative/create",
                        type: "POST",
                        data: {
                                name: self.name,
                                code:self.code,
                                id: segments[3],
                                module: self.repModule.value,
                                location_id: self.locationId.value,
                                telephone: self.telephone
                            },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateRepBtn").val("Update");
                                $("#CreateRepBtn").prop("disabled", false);
                                $("#cancelRepBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueRepBtn").val("Save and Continue");
                                    $("#CreateRepBtn").prop("disabled", false);
                                    $("#createAndContinueRepBtn").prop("disabled", false);
                                    $("#cancelRepBtn").prop("disabled",false);

                                }else{

                                    $("#CreateRepBtn").val("Save");
                                    $("#CreateRepBtn").prop("disabled", false);
                                    $("#createAndContinueRepBtn").prop("disabled", false);
                                    $("#cancelRepBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    $("#RepForm").trigger("reset");
                                    self.name ="";
                                    self.code = "";
                                    self.description = "";
                                    self.telephone = "";

                                }else{
                                    self.$router.push("/representative/list");
                                }

                            } else {

                                if (data.code == 201 ) {

                                    $("#errorMsg").text(data.message);
                                    $(".alert-warning").toggleClass("show");
                                }
                            }
                        },
                        error: function (jqXHR, exception) {

                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateRepBtn").val("Update");
                                $("#CreateRepBtn").prop("disabled", false);
                                $("#cancelRepBtn").prop("disabled",false);

                            } else {

                                if (flag == "Save and Continue") {

                                    $("#RepForm").trigger("reset");

                                    $("#createAndContinueRepBtn").val("Save and Continue");
                                    $("#CreateRepBtn").prop("disabled", false);
                                    $("#createAndContinueRepBtn").prop("disabled", false);
                                    $("#cancelRepBtn").prop("disabled",false);

                                } else {

                                    $("#CreateRepBtn").val("Save");
                                    $("#CreateRepBtn").prop("disabled", false);
                                    $("#createAndContinueRepBtn").prop("disabled", false);
                                    $("#cancelRepBtn").prop("disabled",false);
                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'term-create')
                        }
                    });
            }

        },

        loadRepresentative() {
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/representative/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    if (data.status == "success") {
                        self.name = data.content.name;
                        self.code = data.content.code;
                        self.repModule = {text:self.titleCase(data.content.module),value:data.content.module};
                        if ( data.content.location_id ) {
                            self.locationId = {text:data.content.locCode+" | "+self.titleCase(data.content.locName),value:data.content.location_id};
                        } else {
                            self.locationId = NULL;
                        }
                        if(data.content.telephone){
                          self.telephone = data.content.telephone;
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'term-load-by-id')
                }
            });
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/representative/RepresentativeCreate.vue